import { render, staticRenderFns } from "./EditAdmin.vue?vue&type=template&id=7e4bb829&scoped=true&"
import script from "./EditAdmin.vue?vue&type=script&lang=js&"
export * from "./EditAdmin.vue?vue&type=script&lang=js&"
import style0 from "./EditAdmin.vue?vue&type=style&index=0&id=7e4bb829&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4bb829",
  null
  
)

export default component.exports